export interface Role {
  company: string;
  companyUrl?: string;
  location: string;
  title: string;
  start: string;
  end: string;
  summary: string;
  bullets: string[];
  stack: string[];
  current?: boolean;
}

export const experience: Role[] = [
  {
    company: "Mohammed Bin Haider Holding Group",
    location: "Dubai, UAE",
    title: "Lead Full Stack Developer",
    start: "May 2026",
    end: "Present",
    current: true,
    summary:
      "Leading full-stack development across the group's digital products: architecture, delivery and the engineering team.",
    bullets: [
      "Own technical direction and architecture for new and existing platforms.",
      "Lead the full-stack team through planning, code review and release.",
    ],
    stack: ["React", "TypeScript", "Node.js", "NestJS", "PostgreSQL", "AWS", "Docker"],
  },
  {
    company: "Smart DCC",
    location: "Dubai, UAE",
    title: "Senior Full Stack Developer",
    start: "Nov 2024",
    end: "May 2026",
    summary:
      "Built three AI-enabled products from the ground up: an enterprise HRM SaaS, an ML bird-detection system and a smart delivery platform.",
    bullets: [
      "Architected a scalable HRM platform on React 18, TypeScript, Redux Toolkit and RBAC: 15+ modules, AI-assisted workflows, OCR onboarding and bilingual English/Arabic RTL support, cutting manual data entry by 70%.",
      "Built an AI-powered bird detection and automated feeder system with ML-based classification, MQTT real-time communication and a low-latency React + Redux monitoring dashboard.",
      "Engineered AHLN Box, a smart last-mile delivery solution integrating tablet UI, camera and barcode scanning, delivered with Agile/Scrum, CI/CD and automated testing for reliable proof of delivery.",
    ],
    stack: ["React 18", "TypeScript", "Redux Toolkit", "Node.js", "NestJS", "MQTT", "OpenAI API", "CI/CD"],
  },
  {
    company: "IncuseHR",
    companyUrl: "https://incusehr.com/",
    location: "Bangalore, India",
    title: "Team Lead",
    start: "Jul 2023",
    end: "Apr 2024",
    summary: "Led the Incuse HRMS SaaS: full-stack architecture, backend performance and a mobile-first React UI.",
    bullets: [
      "Designed the full-stack architecture and optimised the Node.js, Express and Redis backend with batch processing, reducing API response time by 70%.",
      "Converted requirements into scalable solutions and oversaw code reviews, debugging and code quality.",
      "Built responsive, mobile-first React.js interfaces from Figma designs to improve user experience and workflows.",
    ],
    stack: ["Node.js", "Express", "Redis", "React", "Redux", "MongoDB", "AWS"],
  },
  {
    company: "BackB Solutions",
    companyUrl: "https://www.backb.in/",
    location: "Kochi, India",
    title: "Full Stack Developer",
    start: "Oct 2019",
    end: "Jul 2023",
    summary:
      "Designed and shipped multi-role food delivery and e-commerce platforms for web and mobile, from architecture to app-store release.",
    bullets: [
      "Built the Whakaaro food delivery platform: secure authentication, role-based access control, order management, real-time tracking, payment gateway integration and notifications.",
      "Deployed and maintained the applications on cloud environments, handling configuration, scaling and production issue resolution.",
      "Led MERN-stack development of the Sindibad e-commerce apps for web and mobile, with deployments to the Play Store and App Store.",
      "Built responsive, high-performance React.js interfaces optimised for cross-browser compatibility.",
    ],
    stack: ["Node.js", "MongoDB", "Express", "React", "React Native", "socket.io", "Redux", "AWS"],
  },
];
